module.exports = __webpack_public_path__ + "img/mate-card_vic.4316ac7.png";